export default "__VITE_ASSET__BNnA4jJS__"